import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import HintCellRenderer from '../CellRenderers/HintCellRenderer'
import { positiveSparklineOptions, negativeSparklineOptions } from '../Options'
import { formatPercent } from '../utils'

export const hintsDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'hintAvg',
      cellRenderer: HintCellRenderer,
      field: 'hint',
      headerName: 'Hint',
      maxWidth: 70,
      pinned: 'left',
      suppressHeaderMenuButton: true,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'breakevenProbabilityAvg',
      cellRenderer: 'agSparklineCellRenderer',
      cellRendererParams: {
        sparklineOptions: positiveSparklineOptions,
      },
      field: 'breakeven_probability',
      headerName: 'Breakeven %',
      headerTooltip: 'Breakeven Probability',
      pinned: 'left',
      suppressHeaderMenuButton: true,
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'marginMinus10ProbabilityAvg',
      cellRenderer: 'agSparklineCellRenderer',
      cellRendererParams: {
        sparklineOptions: negativeSparklineOptions,
      },
      field: 'margin_minus_10_probability',
      headerName: 'M-10%',
      headerTooltip: 'Worse than -10% Margin Probability',
      maxWidth: 80,
      suppressHeaderMenuButton: true,
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'margin10ProbabilityAvg',
      cellRenderer: 'agSparklineCellRenderer',
      cellRendererParams: {
        sparklineOptions: positiveSparklineOptions,
      },
      field: 'margin_10_probability',
      headerName: 'M+10%',
      headerTooltip: 'Better than 10% Margin Probability',
      maxWidth: 80,
      suppressHeaderMenuButton: true,
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'margin25ProbabilityAvg',
      cellRenderer: 'agSparklineCellRenderer',
      cellRendererParams: {
        sparklineOptions: positiveSparklineOptions,
      },
      field: 'margin_25_probability',
      headerName: 'M+25%',
      headerTooltip: 'Better than 25% Margin Probability',
      maxWidth: 80,
      suppressHeaderMenuButton: true,
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'Hints',
}
